class Version {
  getVersion() {
    return "3.7.0"
  }
}

export default new Version()
